import {createSlice, type PayloadAction} from "@reduxjs/toolkit";
import type {PricingResponse} from "../model/contracts/PricingResponse.ts";

/**
 * Holds the result of a tariff calculation while the user is on the contract
 * detail page. Stays in Redux (not TanStack-Query) because the tariff is
 * computed via a POST submit, not a GET — the calculate flow is stateful UI
 * rather than server data.
 *
 * Earlier this slice also held `tariffFilter`, `loading`, `username`,
 * `selectedContract`, `contractTerm`, `additionalConditions` — none of those
 * had real consumers. Removed in M7 cleanup.
 */
export interface PricingState {
    pricingResponse: PricingResponse | null;
}

const initialState: PricingState = {
    pricingResponse: null,
};

export const pricingSlice = createSlice({
    name: "pricing",
    initialState,
    reducers: {
        calculateTariffSuccess: (state, action: PayloadAction<PricingResponse | null>) => {
            state.pricingResponse = action.payload;
        },
        clearTariff: state => {
            state.pricingResponse = null;
        },
    },
});

export const pricingReducerActions = pricingSlice.actions;

export default pricingSlice.reducer;
